import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { ZemplinLoaderWrapper } from '../../..';
import { TableWrapper } from '../General/TableWrapper';
import { TableRow, SecondTableTh } from '../General/Table';
import { OrderRow } from './OrderRow';
import { SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  orders: any;
  isFetching: boolean;
  onOrderAgain: (publicId: string) => void;
}

function Orders({ orders, isFetching, onOrderAgain }: Props) {
  const columns = [
    { name: 'Obj. číslo' },
    { name: 'Dátum' },
    { name: 'Suma', width: '100%' },
    { name: 'Faktúra' },
    { name: 'Stav', minWidth: rem(148) },
    { name: 'Zopakovať objednávku' },
  ];
  const headers =
    columns &&
    columns.map((item: any) => (
      <SecondTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={item.name}
      >
        {item.name}
      </SecondTableTh>
    ));

  const orderRows =
    orders &&
    orders.map((order: any) => (
      <OrderRow
        key={order.order_id}
        order={order}
        onOrderAgain={onOrderAgain}
      />
    ));

  return (
    <Wrapper>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : (
        <>
          <HorizontalScrollButton>
            <SvgIcon
              icon={IconType.scroll}
              alt={__('Scroll')}
              width={23}
              height={10}
              fill={'#000000'}
              viewBox="3 0 18 12"
            />
          </HorizontalScrollButton>
          <TableWrapper
            tableHasBorder={false}
            tableHasBoxShadow={false}
            noItemsText={__('Nenašli sa žiadne objednávky')}
            headers={headers}
            rows={orderRows}
          />
        </>
      )}
    </Wrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: ${rem(24)};
  animation: ${animateIn} 0.2s ease;
  margin-top: ${rem(32)};
  position: relative;

  ${({ theme }) => theme.mediab.m810`
       margin: 0;
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
      margin-right: -${rem(16)};
  `};
`;

const HorizontalScrollButton = styled.div`
  display: none;
  position: absolute;
  top: ${rem(18)};
  right: ${rem(16)};
  height: ${rem(24)};
  width: ${rem(48)};
  /* display: flex; */
  justify-content: center;
  align-items: center;
  border-radius: ${rem(12)};
  box-shadow: 0px 1px 2px #00000029;
  border: 1px solid #cccccc;
  opacity: 0.8;

  ${({ theme }) => theme.mediab.l925`
      display: flex;
  `};
`;

export { Orders };
